export default {
  /**
   * @returns {Date}
   */
  lastYear() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    return date;
  },

  /**
   * @returns {Date}
   */
  today() {
    return new Date();
  },

  /**
   * @param date
   * @returns {string}
   */
  getIsoDateString(date) {
    return date.toISOString().substr(0, 10);
  },
};



// WEBPACK FOOTER //
// ./src/services/date-service.js